const lineColors = {
  line1: "7F3E98", // 법학관
  line2: "ECCA1A", // 수선관
  line3: "EBA824", // 수선관별관
  line4: "684219", // 호암관
  line5: "BB94C4", // 퇴계인문관
  line6: "2D439C", // 다산경제관
  line7: "37C5EC", // 경영관
  line8: "39B54A", // 교수회관
  line9: "ED1C24", // 중앙 도서관
  line10: "056839", // 600주년 기념관
  line11: "EC008C", // 국제관
  line12: "6CC5A6", // 학생회관
};

export default lineColors;
